module.exports = __webpack_public_path__ + "img/playace.58221ffe.png";